import script from "./delete_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./delete_btn.vue?vue&type=script&setup=true&lang=js"

import "./delete_btn.vue?vue&type=style&index=0&id=217c063c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-217c063c"]])

export default __exports__